/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Characternameluni2Inputs */



/**
* | output |
* | --- |
* | "Luni" |
*
* @param {Characternameluni2Inputs} inputs
* @param {{ locale?: "ru" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const characternameluni2 = /** @type {((inputs?: Characternameluni2Inputs, options?: { locale?: "ru" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Characternameluni2Inputs, { locale?: "ru" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Luni")
	if (locale === "es") return /** @type {LocalizedString} */ ("Luni")
	return /** @type {LocalizedString} */ ("Луни")
});
export { characternameluni2 as "characterNameLuni" }